import { authorizedEdgeFetch } from 'app/axios/edge'
import { UpdateDealerRequest } from './types'

export const getDealerAccess = (homeId: string) =>
  authorizedEdgeFetch.get(`homes/${homeId}/access`)

export const updateDealerAccess = (payload: UpdateDealerRequest) =>
  authorizedEdgeFetch.put(`homes/${payload.homeId}/access`, payload)
